import { Component, Inject, OnInit } from '@angular/core';
import { CameraServerService } from '../../camera-server.service';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from 'src/app/shared/app-constants';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { timeZoneService } from 'src/app/services/timezone.service';
import moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';

export const FOOTAGE_FORMAT = [
  { id: 1, name: "Mp4", value: "Mp4" },
  { id: 2, name: "Mov", value: "Mov" },
  { id: 3, name: "Mjpg", value: "Mjpg" },
]
export const DOWNLOAD_FOOTAGE_TYPE = [
  { id: 1, name: "With motion detection", value: "With motion detection" },
  { id: 2, name: "Without motion detection", value: "Without motion detection" },
]
@Component({
  selector: 'app-footage-download',
  templateUrl: './footage-download.component.html',
  styleUrls: ['./footage-download.component.scss']
,
  standalone: false
})
export class FootageDownloadComponent implements OnInit {

  headerName: string = '';
  potentialName: string = '';
  potentialId: string = '';
  loading: boolean = false;
  formatList: any = FOOTAGE_FORMAT;
  downloadFootageTypeList: any = DOWNLOAD_FOOTAGE_TYPE;
  cameraLists: any = [];
  selectedCamera: any;
  selectedFormat: string = 'Mp4';
  startDateTime: any = '';
  endDateTime: any = '';
  startDateOnly: string = '';
  endDateOnly: string = '';
  selectedDownloadFootageType: string = 'With motion detection';
  footageRetentionDays: number;
  minStartDate: Date;
  maxStart: Date = new Date();
  minEndDate: Date = new Date();
  maxEnd: Date = new Date();
  fromDate: any;
  toDate: any;
  showTimeRangeError: string = ''
  isButtonDisabled: boolean = true;
  show12HrLimitMessage: boolean = false;
  requestPlacedSuccessfully: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FootageDownloadComponent>,
    private camService: CameraServerService,
    public spinner: SpinnerService,
    private toaster: ToastrService,
    private timeZoneService: timeZoneService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.headerName = "Initiate - Footage Download";
    this.potentialId = this.data?.vtigerPotentialId;
    this.potentialName = this.data?.potentialName;
    this.footageRetentionDays = parseInt(this.data?.storageDays)
    this.getCameraBySite();
    this.formatSdt();
    // this.getDefaultData();
  }

  /**Get camera by site potential ID */
  getCameraBySite() {
    if (this.potentialId) {
      this.spinner.activate();
      this.loading = true;
      this.camService.getCamByPotentialId(this.potentialId).subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          if (response?.data?.cams !== null) {
            this.cameraLists = response?.data?.cams || [];
          } else {
            this.cameraLists = [];
          }
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toaster.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toaster.error(err.error.message, 'Error');
        } else {
          this.toaster.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /** Methods for selecting the camera */
  handleSelectCamera(event: any) { }

  /** Methods for selecting the start date */
  selectStartDate(event: any) {
    this.startDateTime = new Date(event.target.value);
    this.formatSdt();
    this.calculateMaxEndDate();
  }

  /** Methods for selecting the end date */
  selectEndDate(event: any) {
    this.endDateTime = new Date(event.target.value);
    this.formatSdt();
    this.calculateMaxEndDate();
  }

  /** Start date and time change */
  dataTimeChange(e: any) {
    var newDate = new Date(e);
    this.startDateTime = newDate;
    this.minEndDate = new Date(e);
    this.endDateTime = new Date(newDate);
    const enterStartData = new Date(e);
    const convertInfoCurrentData = enterStartData.getTime();
    const fromServerDataTime = new Date(this.fromDate);
    const convertInfoFromServerDataTime = fromServerDataTime.getTime();
    if (moment(convertInfoFromServerDataTime).isBefore(convertInfoCurrentData)) {
      let currentEndDateTime = new Date(this.toDate);
      this.endDateTime.setHours(currentEndDateTime.getHours(), currentEndDateTime.getMinutes(), currentEndDateTime.getSeconds());
    } else {
      // add one hour 
      this.endDateTime.setHours(this.endDateTime.getHours() + 1);
    }
  }

  /** Calculate max end date based on start date */
  calculateMaxEndDate() {
    const maxLimit = new Date(this.startDateTime.getTime() + 12 * 60 * 60 * 1000);
    this.show12HrLimitMessage = this.endDateTime > maxLimit;
  }

  /** This methods is used downloading the footage*/
  handleDownload() {
    const currentUser: any = this.authService.currentUserValue;
    const firstName: string = currentUser?.firstName;
    const payload = {
      potential_id: `${this.potentialId}`,
      cam_unique_id: this.selectedCamera?.camUniqueId,
      cam_name: this.selectedCamera?.cameraName,
      from_date: moment(this.startDateTime).format('YYYY-MM-DD HH:mm:ss'),
      to_date: moment(this.endDateTime).format('YYYY-MM-DD HH:mm:ss'),
      site_name: this.potentialName,
      user_name: firstName,
      md: this.selectedDownloadFootageType == 'With motion detection'
    }
    this.spinner.activate();
    this.loading = true;
    this.camService.footageDownload(payload).subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        this.dialogRef.close()
        this.toaster.success("Goto footage page and download it once its processing is completed.");
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toaster.warning(response.message || AppConstants.defaultErrorMessage);
      }
    }, (err) => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toaster.error(err.error.message, 'Error');
      } else {
        this.toaster.error(AppConstants.defaultErrorMessage, 'Error');
      }
    })
  }

  /** This methods is used for formatting the date and time base on the user selection */
  formatSdt() {
    const startDate = new Date(this.startDateTime);
    const startMonth = ('0' + (startDate.getMonth() + 1)).slice(-2);
    const startDay = ('0' + startDate.getDate()).slice(-2);
    const startYear = startDate.getFullYear();
    this.startDateOnly = startMonth + '-' + startDay + '-' + startYear;

    const endDate = new Date(this.endDateTime);
    const endMonth = ('0' + (endDate.getMonth() + 1)).slice(-2);
    const endDay = ('0' + endDate.getDate()).slice(-2);
    const endYear = endDate.getFullYear();
    this.endDateOnly = endMonth + '-' + endDay + '-' + endYear;

    const now = new Date();
    const options = { timeZone: 'UTC' as const, year: 'numeric' as const, month: '2-digit' as const, day: '2-digit' as const, hour: '2-digit' as const, minute: '2-digit' as const, second: '2-digit' as const };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const formattedDate = formatter.format(now).replace(/\//g, '-').slice(0, -3);
    /*
    if (startDate && endDate) {
      const diff = Math.abs(endDate.getTime() - startDate.getTime());
      const diffHours = diff / (1000 * 60 * 60);
      if (diffHours > 5) {
       this.showTimeRangeError ="Please select time gap 5hr between the start and end date time";
      }else{
        this.showTimeRangeError ="";
      }
    } */

  }

  /** Load default date and by default retention days is 14 days */
  getDefaultData() {
    let siteTimezone = this.data?.timeZone;
    let siteDateTime: any = this.timeZoneService.getDateParametersByTimeZone(siteTimezone);
    let fromDt = siteDateTime.currentTime;
    let calenderFrom = siteDateTime.currentTime;
    let toDt = siteDateTime.currentTime;
    let calenderTo = siteDateTime.currentTime;
    this.fromDate = fromDt;
    this.toDate = toDt;
    var stNewDate = new Date(calenderFrom);
    this.startDateTime = stNewDate;
    // date picker update hours 
    this.maxStart.setHours(stNewDate.getHours() + 1, stNewDate.getMinutes());

    var endNewDate = new Date(calenderTo);
    this.endDateTime = endNewDate
    this.maxEnd.setHours(endNewDate.getHours(), endNewDate.getMinutes());

    this.minEndDate = new Date(calenderTo);
    this.minEndDate.setHours(this.minEndDate.getHours() - 2, this.minEndDate.getMinutes());

    // date picker set Retention days 
    var dateOffset = (24 * 60 * 60 * 1000) * this.footageRetentionDays;
    this.minStartDate = new Date(+new Date - dateOffset);
    this.minStartDate.setHours(stNewDate.getHours(), stNewDate.getMinutes());
  }

  /**Instant Download Functionality */
  handleInstantDownload(){
    const currentUser: any = this.authService.currentUserValue;
    const firstName: string = currentUser?.firstName;
    const fromDateTime = moment(this.startDateTime);
    const toDateTime = moment(this.endDateTime);

    // Check if from_date and to_date are the same
    if (fromDateTime.isSame(toDateTime)) {
      this.toaster.error('From date and to date cannot be the same.');
      return; // Exit function if dates are the same
    }
    const payload = {
      potential_id: `${this.potentialId}`,
      cam_unique_id: this.selectedCamera?.camUniqueId,
      cam_name: this.selectedCamera?.cameraName,
      from_date: fromDateTime.format('YYYY-MM-DD HH:mm:ss'),
      to_date: toDateTime.format('YYYY-MM-DD HH:mm:ss'),
      site_name: this.potentialName,
      user_name: firstName,
      md: this.selectedDownloadFootageType == 'With motion detection'
    }
    let fromDateFormat = fromDateTime.format('YYYY-MM-DD HH:mm:ss');
    this.camService.handleInstantDownloadFootage(payload,this.selectedCamera, fromDateFormat);
    this.requestPlacedSuccessfully = true;
   setTimeout(() => {
     this.dialogRef.close();
   }, 2000);
  }
  downloadMp4File(response, fileName){
    const url = window.URL.createObjectURL(response);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${fileName}.mp4`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
